var indentation_default = {
  "indentZero": "xWScu",
  "indentOne": "eW80F",
  "indentTwo": "GbDLM",
  "indentThree": "-Jj3d",
  "indentFour": "FK0Hc",
  "indentFive": "yggYv",
  "indentSix": "_2ve-A"
};
export {
  indentation_default as default
};
//# sourceMappingURL=indentation-scss.js.map
